import { Suspense } from 'react'

import { RouteObject } from 'react-router-dom'

import { CreateOrderLazy } from 'routes/Dashboard/routes/Orders/routes/Create'
import { OrderDetailLazy } from 'routes/Dashboard/routes/Orders/routes/[order]'

import { ContentLoader } from 'shared/ui/ContentLoader'

import RestaurantsOrders from './routes/[restaurant]'
import { CreateOrderWrapperLazy, RestaurantWrapperLazy } from './ui'

export const ordersRoutes: RouteObject[] = [
  {
    path: 'orders',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <RestaurantWrapperLazy />
      </Suspense>
    ),
    children: [
      {
        path: ':restaurant',
        element: <RestaurantsOrders />,
      },
    ],
  },
  {
    path: 'orders/:restaurant/:orderId',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <OrderDetailLazy />
      </Suspense>
    ),
  },
  {
    path: 'orders/:restaurant/create',
    element: <CreateOrderWrapperLazy />,
    children: [
      {
        path: ':newOrderId',
        element: (
          <Suspense fallback={<ContentLoader />}>
            <CreateOrderLazy />
          </Suspense>
        ),
      },
    ],
  },
]
